import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '@': 'editingStakeholderAnalysis',
  },
  subqueries: {
    editingStakeholderAnalysis: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'stakeholderId',
          },
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      quantity: 1,
      selection: {
        '{}': {
          name: 'Edit Stakeholder Analysis',
          type: 'details',
          alias: 'edit.stakeholder.modal',
          watch: {
            '[]': [
              {
                '{}': {
                  alias: 'save.stakeholder',
                },
              },
            ],
          },
          content: {
            '{}': {
              fields: {
                '[]': [
                  {
                    '{}': {
                      id: 'stakeholderCode',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Stakeholder ID',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!code',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderName',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Stakeholder Name',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!name',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'employeeName',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Employee Name',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'employeeName',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'employeeOrganization',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Department / Organization',
                              type: {
                                '{}': {
                                  dimensionId: 'dim::!org',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'employeeOrganization',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'employeeJobTitle',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Job Title / Role',
                              type: {
                                '{}': {
                                  dimensionId: 'dim::!job_titles',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@': 'employeeJobTitle',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderProjectTeam',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Project Team Member',
                              type: 'BOOL',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!is_project_team_member',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderProjectRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Project Role',
                              type: {
                                '{}': {
                                  enumId: 'enum::!stakeholder_project_role',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!project_role',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderSystemUserRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'System / User Role',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!system_user_role',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderDegreeOfImpact',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Degree of Impact',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!degree_of_impact',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderInfluenceDecisionRole',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Influence / Decision Role',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!influence_decision_role',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderChangeChampion',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Change Champion',
                              type: {
                                '{}': {
                                  enumId: 'enum::!stakeholder_change_champion',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!change_champion',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderEngagementNeeded',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Engagement Needed',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!stakeholder_engagement_needed',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!engagement_needed',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderValidationStatus',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Validation Status',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!change_impact_validation_status',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!validation_status',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderUnderstanding',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Understanding',
                              type: {
                                '{}': {
                                  enumId: 'enum::!change_impact_rank',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!understanding',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderPerceivedAttitude',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Perceived Attitude',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!stakeholder_perceived_attitude',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!perceived_attitude',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderPotentialConcernsRisks',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Potential Concerns / Risks',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!concerns_risks',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderSupportNeeds',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Support Needs',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!support_needs',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderCommunicationAudience',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Communication Audience / Group',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!comm_audience',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderTrainingAudienceNeed',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Training Audience / Need',
                              type: {
                                '{}': {
                                  enumId:
                                    'enum::!stakeholder_training_audience',
                                  isMultiselect: false,
                                },
                              },
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!training_audience_need',
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'stakeholderNotesFollowUp',
                      meta: {
                        '{}': {
                          direct: {
                            '{}': {
                              name: 'Notes / Follow-Up',
                              type: 'TEXT',
                            },
                          },
                        },
                      },
                      value: {
                        '@.': '!notes_follow_up',
                      },
                    },
                  },
                ],
              },
              onSave: {
                '{}': {
                  action: {
                    '{}': {
                      alias: 'save.stakeholder',
                    },
                  },
                  variables: {
                    '{}': {
                      employeeName: '${field:employeeName}',
                      stakeholderId: {
                        '@.': '!id',
                      },
                      stakeholderCode: '${field:stakeholderCode}',
                      stakeholderName: '${field:stakeholderName}',
                      employeeJobTitle: '${field:employeeJobTitle}',
                      employeeOrganization: '${field:employeeOrganization}',
                      stakeholderProjectRole: '${field:stakeholderProjectRole}',
                      stakeholderProjectTeam: '${field:stakeholderProjectTeam}',
                      stakeholderSupportNeeds:
                        '${field:stakeholderSupportNeeds}',
                      stakeholderNotesFollowUp:
                        '${field:stakeholderNotesFollowUp}',
                      stakeholderUnderstanding:
                        '${field:stakeholderUnderstanding}',
                      stakeholderChangeChampion:
                        '${field:stakeholderChangeChampion}',
                      stakeholderDegreeOfImpact:
                        '${field:stakeholderDegreeOfImpact}',
                      stakeholderSystemUserRole:
                        '${field:stakeholderSystemUserRole}',
                      stakeholderEngagementNeeded:
                        '${field:stakeholderEngagementNeeded}',
                      stakeholderValidationStatus:
                        '${field:stakeholderValidationStatus}',
                      stakeholderPerceivedAttitude:
                        '${field:stakeholderPerceivedAttitude}',
                      stakeholderTrainingAudienceNeed:
                        '${field:stakeholderTrainingAudienceNeed}',
                      stakeholderCommunicationAudience:
                        '${field:stakeholderCommunicationAudience}',
                      stakeholderInfluenceDecisionRole:
                        '${field:stakeholderInfluenceDecisionRole}',
                      stakeholderPotentialConcernsRisks:
                        '${field:stakeholderPotentialConcernsRisks}',
                    },
                  },
                },
              },
              columnCount: 2,
            },
          },
        },
      },
      subqueries: {
        employeeName: {
          ref: {
            attr: 'attr:ent#!stakeholders#!stakeholder:!employee',
          },
          target: 'ent:!personnel:!employee',
          quantity: 1,
          selection: {
            '@.': '!name',
          },
        },
        employeeJobTitle: {
          ref: {
            attr: 'attr:ent#!stakeholders#!stakeholder:!employee',
          },
          target: 'ent:!personnel:!employee',
          quantity: 1,
          selection: {
            '@.': '!job_title',
          },
        },
        employeeOrganization: {
          ref: {
            attr: 'attr:ent#!stakeholders#!stakeholder:!employee',
          },
          target: 'ent:!personnel:!employee',
          quantity: 1,
          selection: {
            '@.': '!org',
          },
        },
      },
    },
  },
}
